import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { QaIdentifier, useQa } from 'hooks/useQa';

import { getFormattedPrice, PriceFormatter } from 'utility/Format/Price';

import styles from './Price.module.scss';

export interface PriceProps {
    /** Total price */
    value: number;
    isStrikeThroughPrice?: boolean;
    customClass?: string;
    withPrefix?: boolean;
}

const Price = ({
    value,
    isStrikeThroughPrice = false,
    customClass,
    withPrefix = true,
}: PriceProps) => {
    const { t } = useTranslation();
    const qaAttr = useQa(
        isStrikeThroughPrice
            ? QaIdentifier.Accommodation_Pricing_Price_Original
            : QaIdentifier.Accommodation_Pricing_Price
    );
    const formattedValue = getFormattedPrice(
        value,
        PriceFormatter.WithFractionDigits
    );

    return (
        <span
            className={classNames(
                {
                    [styles.StrikeThroughPrice]: isStrikeThroughPrice,
                    [styles.Price]: !isStrikeThroughPrice,
                },
                customClass
            )}
            dangerouslySetInnerHTML={{
                __html: isStrikeThroughPrice
                    ? formattedValue
                    : withPrefix
                    ? t('TRANS-price-from', {
                          price: formattedValue,
                      })
                    : formattedValue,
            }}
            {...qaAttr}
        />
    );
};

export default Price;
